"use strict";
/*
  The MIT License
  
  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms
  
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:
  
  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCombinatorRenderInfos = exports.resolveSubSchemas = void 0;
var tslib_1 = require("tslib");
var resolvers_1 = require("./resolvers");
var reducers_1 = require("../reducers");
var createLabel = function (subSchema, subSchemaIndex, keyword) {
    if (subSchema.title) {
        return subSchema.title;
    }
    else {
        return keyword + '-' + subSchemaIndex;
    }
};
var resolveSubSchemas = function (schema, rootSchema, keyword) {
    var _a;
    // resolve any $refs, otherwise the generated UI schema can't match the schema???
    var schemas = schema[keyword];
    if (schemas.findIndex(function (e) { return e.$ref !== undefined; }) !== -1) {
        return tslib_1.__assign(tslib_1.__assign({}, schema), (_a = {}, _a[keyword] = schema[keyword].map(function (e) {
            return e.$ref ? resolvers_1.resolveSchema(rootSchema, e.$ref) : e;
        }), _a));
    }
    return schema;
};
exports.resolveSubSchemas = resolveSubSchemas;
var createCombinatorRenderInfos = function (combinatorSubSchemas, rootSchema, keyword, control, path, uischemas) {
    return combinatorSubSchemas.map(function (subSchema, subSchemaIndex) { return ({
        schema: subSchema,
        uischema: reducers_1.findUISchema(uischemas, subSchema, control.scope, path, undefined, control, rootSchema),
        label: createLabel(subSchema, subSchemaIndex, keyword)
    }); });
};
exports.createCombinatorRenderInfos = createCombinatorRenderInfos;
//# sourceMappingURL=combinators.js.map